import { AsyncDeletableStatusUpdate } from '../../../product/dto/async-deletable-status-update';
import { WebSocketReceiveMessage } from './web-socket-receive-message';

export class WebSocketAsyncDeleteStatusUpdate extends WebSocketReceiveMessage {
  override payload: AsyncDeletableStatusUpdate;

  override onDeserialize() {
    this.payload = window?.injector?.Deserialize.instanceOf(AsyncDeletableStatusUpdate, this.payload);
  }
}
